import { useGalleryCtx } from "@/contexts/gallery";
import { motion } from "framer-motion";
import ViewAllBtn from "../common/view-all";
import { useWinners } from "../contexts/winners-context";
import Card from "../common/card";
import { YearFilter, YearQuery } from "../common/filter";

export default function DesktopView({ data }: any) {
  const { setCurrentGalleryItems, setCurrentGalleryItem } = useGalleryCtx();
  const {
    pageNo,
    year,
    loading,
    setPageNo,
    setYear,
    loadingMore,
    winners,
    reachedEnd,
  } = useWinners();
  function openExpandedView(index: number) {
    setCurrentGalleryItem(index);
    setCurrentGalleryItems(winners);
  }

  return (
    <motion.div
      key="default"
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 50 }}
      transition={{ duration: 0.5 }}
      className="hidden lg:block"
    >
      <div className="flex justify-between pb-10">
        <h1 className="text-[48px] text-secondary ltr:font-playfair ltr:tracking-[0.03em]">
          {data.title}
        </h1>
        <div className="flex gap-4">
          <YearFilter
            yearQuery={YearQuery.WINNERS_YEAR}
            years={data.year_filter_text.years}
            year={year}
            setYear={setYear}
          />
        </div>
      </div>
      <div className="grid grid-cols-3 gap-6">
        {winners.map((perf, index) => (
          <Card
            item={perf}
            key={index}
            onClick={() => openExpandedView(index)}
            loading={loading}
          />
        ))}
      </div>
      <ViewAllBtn
        loadingMore={loadingMore}
        text={data.button_text}
        pageNo={pageNo}
        setPageNo={setPageNo}
        reachedEnd={reachedEnd}
      />
    </motion.div>
  );
}
